import { ThemeProvider } from "./components/ThemeProvider";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Qease from "./pages/Qease";
import CareLine from "./pages/CareLine";
import ClinicLanding from "./pages/ClinicLanding";
import CareLineFAQ from "./pages/CareLineFAQ";
import Payment from "./pages/Payment";
import PaymentSuccess from "./pages/PaymentSuccess";
import Login from "./pages/Login";
import ClinicLogin from "./pages/ClinicLogin";
import ClinicRegister from "./pages/ClinicRegister";
import Polyclinics from "./pages/Polyclinics";
import Doctors from "./pages/Doctors";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";
import SuperAdminClinics from "./pages/SuperAdminClinics";
import SuperAdminUsers from "./pages/SuperAdminUsers";
import ClinicAdminDashboard from "./pages/ClinicAdminDashboard";
import ClinicAdminPoli from "./pages/ClinicAdminPoli";
import ClinicAdminPasien from "./pages/ClinicAdminPasien";
import ClinicAdminAntrian from "./pages/ClinicAdminAntrian";
import ClinicAdminDokter from "./pages/ClinicAdminDokter";
import ClinicAdminSettings from "./pages/ClinicAdminSettings";
import DoctorDashboard from "./pages/DoctorDashboard";
import ScrollToTop from "./components/ScrollToTop";
import PageTransition from "./components/PageTransition";
import DynamicClinicBranding from "./components/DynamicClinicBranding";

function App() {
  return (
    <ThemeProvider
      attribute="class"
      defaultTheme="light"
      enableSystem={false}
      disableTransitionOnChange
    >
      <BrowserRouter>
        <ScrollToTop />
        <DynamicClinicBranding />
        <Routes>
          {/* ── Public ── */}
          <Route path="/" element={<Navigate to="/qease" replace />} />
          <Route path="/qease" element={<PageTransition><Qease /></PageTransition>} />
          <Route path="/careline-faq" element={<PageTransition><CareLineFAQ /></PageTransition>} />
          <Route path="/polyclinics" element={<PageTransition><Polyclinics /></PageTransition>} />
          <Route path="/doctors" element={<PageTransition><Doctors /></PageTransition>} />

          {/* ── Payment ── */}
          <Route path="/payment" element={<Payment />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />

          {/* ── Auth ── */}
          {/* Central login: Admins & Superadmins only */}
          <Route path="/login" element={<Login />} />
          {/* Note: Default /register is completely disabled for admins. */}

          {/* ── Superadmin ── */}
          <Route path="/super-admin" element={<SuperAdminDashboard />} />
          <Route path="/super-admin/clinics" element={<SuperAdminClinics />} />
          <Route path="/super-admin/users" element={<SuperAdminUsers />} />

          {/* ── Clinic Admin (slug-prefixed, e.g. /klinik-sehat/clinic-admin) ── */}
          <Route path="/:slug/clinic-admin" element={<ClinicAdminDashboard />} />
          <Route path="/:slug/clinic-admin/poli" element={<ClinicAdminPoli />} />
          <Route path="/:slug/clinic-admin/pasien" element={<ClinicAdminPasien />} />
          <Route path="/:slug/clinic-admin/antrian" element={<ClinicAdminAntrian />} />
          <Route path="/:slug/clinic-admin/dokter" element={<ClinicAdminDokter />} />
          <Route path="/:slug/clinic-admin/settings" element={<ClinicAdminSettings />} />

          {/* Legacy non-slug clinic-admin routes (backwards compatibility) */}
          <Route path="/clinic-admin" element={<ClinicAdminDashboard />} />
          <Route path="/clinic-admin/poli" element={<ClinicAdminPoli />} />
          <Route path="/clinic-admin/pasien" element={<ClinicAdminPasien />} />
          <Route path="/clinic-admin/antrian" element={<ClinicAdminAntrian />} />
          <Route path="/clinic-admin/dokter" element={<ClinicAdminDokter />} />
          <Route path="/clinic-admin/settings" element={<ClinicAdminSettings />} />

          {/* ── Doctor (tenant slug in URL for branding + API path; legacy route kept) ── */}
          <Route path="/doctor-dashboard" element={<DoctorDashboard />} />
          <Route path="/:slug/dashboard/doctor" element={<DoctorDashboard />} />

          {/* ── Careline demo: exact path only (dummy API slug "careline") ── */}
          <Route path="/careline" element={<PageTransition><ClinicLanding fixedSlug="careline" /></PageTransition>} />

          {/* ── Tenant public landing & patient routes (single segment slug must stay below /qease, /login, etc.) ── */}
          <Route path="/:slug/login" element={<ClinicLogin />} />
          <Route path="/:slug/register" element={<ClinicRegister />} />
          <Route path="/:slug/careline" element={<PageTransition><CareLine /></PageTransition>} />
          <Route path="/:slug/poliklinik" element={<PageTransition><Polyclinics /></PageTransition>} />
          <Route path="/:slug/dokter" element={<PageTransition><Doctors /></PageTransition>} />
          <Route path="/:slug/faq" element={<PageTransition><CareLineFAQ /></PageTransition>} />
          <Route path="/:slug" element={<ClinicLanding />} />

          {/* ── Redirects & Fallbacks ── */}
          <Route path="/qease/careline" element={<Navigate to="/careline" replace />} />
          <Route path="*" element={<Navigate to="/qease" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;
